import { AxiosResponse } from 'axios';
import api from './api';

export default {
  batchByUid(uid: string): Promise<AxiosResponse> {
    return api.get(`/batches/batch-by-uid/${uid}`);
  },
};
